<ng-container *ngIf="!!get">
    <ng-container *ngIf="!('mobile' | mediaQuery)">
        <tt-tabs ttRememberId="w_customersmenu.bg_tab1" [(ttSelectedId)]="get.bg_tab1" (ttSelectedIdChange)="onTabSelected($event)">
            <tt-tab *ngIf="get.show_button_edit_customer === '1'" ttId="EDIT" ttLabel="edit_customer" ttIcon="far fa-edit"></tt-tab>
            <tt-tab *ngIf="dashboard.kpiCompKeynos.length > 0" ttId="DASHBOARD" ttLabel="bg_main_dashboard" ttIcon="far fa-analytics"></tt-tab>
            <tt-tab ttId="CONTACTS" ttLabel="customer_persons" ttIcon="far fa-users"></tt-tab>
            <tt-tab ttId="EMAIL" ttLabel="customersmenu_email" ttIcon="far fa-envelope"></tt-tab>
            <tt-tab ttId="PROJECTS" ttLabel="projects" ttIcon="far fa-tasks-alt"></tt-tab>
            <tt-tab ttId="CUSTACTS" ttLabel="activities" ttIcon="far fa-tasks"></tt-tab>
            <tt-tab ttId="ORDERS" ttLabel="quotation_and_orders" ttIcon="far fa-box"></tt-tab>
            <tt-tab ttId="DOCUMENTS" ttLabel="documents" ttIcon="far fa-file-alt"></tt-tab>
            <tt-tab ttId="POWTIMES" ttLabel="customer_powtimes" ttIcon="far fa-clock"></tt-tab>
            <tt-tab *ngIf="get.show_discgrpcust === '1'" ttId="DISCGRPPROD" ttLabel="customer_discgrpprod" ttIcon="far fa-ellipsis-h"></tt-tab>
            <tt-tab ttId="FUNCTIONS" ttLabel="bg_main_functions" ttIcon="far fa-ellipsis-h"></tt-tab>
        </tt-tabs>
        <tt-customer-edit *ngIf="get.show_button_edit_customer === '1'" [hidden]="get.bg_tab1 !== 'EDIT'" [params]="{ cust_no: get.cust_no }"></tt-customer-edit>
        <tt-webpagemenu-dashboard
            [hidden]="get.bg_tab1 !== 'DASHBOARD'"
            #dashboard
            class="col-xs-12 sp-0"
            ttName="customersmenu"
            ttArgtype="cust_no"
            [ttArgvalue]="get.cust_no"
            ttShowHeadingButtons
        ></tt-webpagemenu-dashboard>
        <tt-grid *ngIf="contactsGridLoaded" [hidden]="get.bg_tab1 !== 'CONTACTS'" [(ttOptions)]="contactsGrid"></tt-grid>
        <tt-email-grid *ngIf="emailGridLoaded" [hidden]="get.bg_tab1 !== 'EMAIL'" webpage="customersmenu" argType="cust_no" [argValue]="get.cust_no"></tt-email-grid>
        <tt-projects-grid
            *ngIf="projectsGridLoaded"
            [hidden]="get.bg_tab1 !== 'PROJECTS'"
            [params]="{ argtype: 'cust_no', argvalue: get.cust_no, bg_projects_activestatus: 'ACTIVE', webpage_name: 'customersmenu' }"
        ></tt-projects-grid>
        <tt-activities-grid *ngIf="activitiesGridLoaded" [hidden]="get.bg_tab1 !== 'CUSTACTS'" [params]="{ cust_no: get.cust_no, ok: 'A', businessco_no: get.businessco_no }"></tt-activities-grid>
        <tt-order-heads-grid *ngIf="ordersGridLoaded" [hidden]="get.bg_tab1 !== 'ORDERS'" [params]="{ cust_no: get.cust_no, argtype: 'cust_no', argvalue: get.cust_no }"></tt-order-heads-grid>
        <tt-documents-grid
            *ngIf="documentsGridLoaded"
            [hidden]="get.bg_tab1 !== 'DOCUMENTS'"
            [params]="{ argtype: 'cust_no', argvalue: get.cust_no, searchtext: '', doctype: 'd', onlyFilenames: '0' }"
        ></tt-documents-grid>
        <tt-powtimes-grid
            *ngIf="powtimesGridLoaded"
            [hidden]="get.bg_tab1 !== 'POWTIMES'"
            rememberId="customer_powtimes_grid"
            [params]="{ businessco_no: '99999', date_fom: '1900-01-01', date_tom: '2200-12-31', cust_no: get.cust_no }"
        ></tt-powtimes-grid>
        <tt-grid *ngIf="discountsGridLoaded && get.show_discgrpcust === '1'" [hidden]="get.bg_tab1 !== 'DISCGRPPROD'" [(ttOptions)]="discountsGrid"></tt-grid>
        <tt-customers-menu-functions [hidden]="get.bg_tab1 !== 'FUNCTIONS'" [params]="get"></tt-customers-menu-functions>
    </ng-container>
    <div *ngIf="'mobile' | mediaQuery" class="tt-customers-menu--mobile">
        <tt-card>
            <tt-input ttLabel="cust_name" [(ttModel)]="get.cust_name" ttReadonly></tt-input>
            <tt-textarea ttLabel="cust_address" [(ttModel)]="get.cust_address" ttReadonly></tt-textarea>
        </tt-card>
        <tt-card>
            <tt-input-phone ttLabel="telephone" [(ttModel)]="get.cust_telephone" ttReadonly></tt-input-phone>
            <tt-input ttLabel="cust_www" [(ttModel)]="get.cust_www" tt-buttons="vm.model.customerWorldWideWebButtons" ttReadonly>
                <tt-form-field-button
                    *ngIf="get.cust_www > '' && get.weblink_custweb > ''"
                    buttons
                    ttIcon="fas fa-window-restore"
                    ttTooltip="open_link"
                    [ttTranslateTooltip]="true"
                    (ttClick)="openLink(get.weblink_custweb)"
                ></tt-form-field-button>
            </tt-input>
        </tt-card>
        <tt-customers-menu-functions [params]="get"></tt-customers-menu-functions>
    </div>
</ng-container>
